<script>
    import { Textarea } from '@/components/ui/textarea/index.js';
    import InputError from '@/components/InputError.svelte';
    import { Label } from '@/components/ui/label/index.js';
    import FieldDescription from '@/components/Form/Inputs/FieldDescription.svelte';
    import Debug from '@/components/Debug.svelte';

    let { value = $bindable(), error, field, ...args} = $props();
    let attributes = field.attributes;

    // Check if field is required
    const isRequired = $derived(field?.required === true || attributes?.required === true);

    // Check if required field is empty
    const isEmptyRequired = $derived(isRequired && (!value || value.toString().trim() === ''));
</script>
<div class="grid gap-1">
    <Label for={field.name}>{field.label}{#if isRequired}<span class="text-destructive">*</span>{/if}</Label>
    <FieldDescription>{field.description}</FieldDescription>
    <Textarea
        id={field.name}
        placeholder={field.placeholder}
        bind:value
        aria-invalid={error || isEmptyRequired ? true : undefined}
        {...attributes}
        {...args}
    />
    <InputError class="mt-2" message={error} />
</div>
